export default {"src":"/_next/static/media/bottle-info.67ed7563.svg","height":127,"width":112,"blurWidth":0,"blurHeight":0};